// import urlParam from '@/utils/getUrlParam';

import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
// import myUniSDK from "@/myUniSDK/index";

const urlParam = Vue.prototype.$urlParam

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

function validatePhoneNumber(phoneNumber) {
  // 11位数字，以1开头
  const pattern = /^1\d{10}$/;
  return pattern.test(phoneNumber);
}


const getBaseURL = (location = window.location) => {
  const pathname = location.pathname
  const pathArry1 = pathname.split('web')
  const pathArry2 = (pathArry1[0] || '').split('/')

  const pathArry3 = pathArry2.slice(0, pathArry2.length - 1).join('/')
  const pathArry4 = pathArry3.split('-web/')[0]
  const preUrl = location.origin + pathArry4
  // let baseURL = preUrl + (urlParam?.su ? '/' + urlParam?.su : '/test-server')
  let baseURL = preUrl + (urlParam?.su ? '/' + urlParam?.su : '/')
  // let baseURL = preUrl + (urlParam?.su ? ('/' + urlParam?.su) : "/dxw-server")

  // 生产环境
  if (process.env.NODE_ENV === 'production') {
    // baseURL = preUrl + (urlParam?.su ? "/" + urlParam?.su : "/server");
    baseURL = preUrl + (urlParam?.su ? '/' + urlParam?.su : '/')
    // console.log("使用/server\n");
    console.log('使用/\n')
  }

 /* console.warn('pathArry==', pathArry4)
  console.log('axios ', location, preUrl)
  console.log('axios baseURL', baseURL) */
  return baseURL
}
const baseURL = getBaseURL()
console.log('===============baseURL', baseURL)

const config = {
  // https://grkzbsf.sahcqmu.com:9100/grk-mbsf/internet-web/follow-up-details-page/?lx=1&rwxh=78&patid=4
  // baseURL: process.env.VUE_APP_BASE_API || process.env.VUE_APP_BASE_API || "",
  // baseURL: "https://grkzbsf.sahcqmu.com:9100/grk-mbsf/server",
  baseURL: baseURL,
  timeout: 1000 * 30 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // if (config.loading) {
    //   config.loading.loading.value = true
    // }

    if (config?.data?.phone_num){
      // 校验手机号格式
      if (!validatePhoneNumber(config?.data?.phone_num)) {
        return Promise.reject({msg: '手机号格式错误'})
      }
    }
    config.headers = {
      // token: store?.state?.vuex_isp_app_token || 'WeChatApplet',
      // token: "WeChatApplet",
      Authorization: 'Bearer ' + store?.state?.vuex_app_token|| '',

      ...config.headers
    }
    // config.headers['token'] = 'WeChatApplet'

    // console.log('config.headers', config.headers)

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    // if (response.config.loading) {
    //   res.config.loading.loading.value = false
    // }
    const data = response?.data
    const code = data?.code
    // if (code < 0) {
    //   console.error("_axios.interceptors.response code < 0");

    //   // Vue.prototype?.$myToast?.({
    //   //   message: "interceptors error",
    //   //   type: "error",
    //   //   center: true,
    //   //   showClose: true,
    //   // });

    //   Vue.prototype?.$myNotify?.({
    //     type: "warning",
    //     message: data?.msg || `code: ${code}`,
    //     duration: 1500,
    //   });

    //   return Promise.reject(data);
    // }
    return data
  },
  function (error) {
    // if (error.config.loading) {
    //   config.loading.loading.value = false
    // }
    // Do something with response error
    // Vue.prototype?.$myToast?.({
    //   message: error.message || error.code,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // Vue.prototype?.$myToast?.({
    //   message: error.message || error.code,
    //   type: "error",
    //   center: true,
    //   showClose: true,
    // });
    if (error?.message == `timeout of ${config?.timeout}ms exceeded`) {
      Vue.prototype?.$myNotify?.({
        type: 'danger',
        message: '连接超时',
        duration: 1500
      })
      return Promise.reject(error)
    }

    console.warn('🚀 ~ file: axios.js:136 ~ error : ', error)
    const status = error?.response?.status
    const data = error?.response?.data

    Vue.prototype?.$myNotify?.({
      type: 'danger',
      // message: status || error?.message || "调用失败",
      // 先展示msg，status兜底
      message:
        data?.msg || data?.data || error?.message || status || '调用失败',
      duration: 1500
    })
    // if (status == 401) {
    //   Vue.prototype
    //     ?.$myDialog?.({
    //       title: "登录凭证过期，请重新获取",
    //       showCancelButton: true,
    //       confirmButtonColor: "#ee0a24",
    //       confirmButtonText: "重新获取",
    //     })
    //     .then(() => {
    //       // on confirm
    //       try {
    //         store.commit("setLogout");
    //       } catch (error) {
    //         console.error('this.$store.commit("setLogout") error', error);
    //       }
    //       // myUniSDK?.wxPostMessage({//不退出，否则要重新扫脸
    //       //   action: "myLoginOut",
    //       //   param: {},
    //       // });
    //       // myUniSDK?.forceRefreshToken?.();
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // }
    return Promise.reject(error?.response?.data || error)
  }
)

// Plugin.install = function (Vue, options) {
//   // Vue.axios = _axios;
//   Vue.$axios = _axios;

//   window.axios = _axios;
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return _axios;
//       }
//     },
//     $axios: {
//       get() {
//         return _axios;
//       }
//     },
//   });
// };

// Vue.use(Plugin)

window.axios = _axios
Vue.prototype.$axios = _axios

// export default Plugin;
export default _axios
